<template>
  <div class="modal-card">
    <div class="header-partnership">
      <img
        src="@/assets/images/SUITE_LOGO.png"
        width="50"
        class="spacing-mr-10"
        alt=""
      />
      <h1 class="is-flex flex-1 is-justify-content-center">
        {{ App.ModalPartnership.VERSION }} {{ getVersion }}
      </h1>
      <div class="close-button" @click="close()">
        <b-icon icon="close" type="is-grey" />
      </div>
    </div>
    <div class="card-body is-flex spacing-my-0">
      <p v-if="version && version.date">
        {{ App.Version.TITLE }}
        {{ getVersionDate.toLocaleDateString("pt-BR") }}
      </p>
      <a
        v-if="version && !version.old"
        href="/versoes"
        target="_blank"
        rel="help"
        class="link"
        >{{ App.Version.VIEW_HISTORY }}</a
      >
      <div>
        <div class="label-section spacing-my-10">
          {{ `${App.ModalPartnership.DEVELOPED_BY}:` }}
        </div>
        <div
          class="columns spacing-mx-20 is-vcentered is-justify-content-space-between"
        >
          <b-image
            class="column is-5 is-justified-center"
            :src="require('@/assets/images/seplaglogo.png')"
            alt="Logo SEPLAG"
            :responsive="false"
          />
        </div>
      </div>
      <div>
        <div class="label-section spacing-my-10">
          {{ `${App.ModalPartnership.MAIN_TECHNOLOGIES}:` }}
        </div>
        <div
          class="columns is-multiline spacing-mx-10 is-vcentered is-centered"
        >
          <b-image
            class="logos column is-3_5 is-justified-center"
            :src="require('@/assets/images/VUE_LOGO.png')"
            alt="Logo VUE"
            :responsive="false"
          ></b-image>
          <b-image
            class="logos column is-3_5 is-justified-center"
            :src="require('@/assets/images/PYTHON_LOGO.png')"
            alt="Logo PYTHON"
            :responsive="false"
          ></b-image>
          <b-image
            class="logos column is-3_5 is-justified-center"
            :src="require('@/assets/images/POSTGRES_LOGO.png')"
            alt="Logo POSTGRES"
            :responsive="false"
          ></b-image>
          <b-image
            class="logos column is-3_5 is-justified-center"
            :src="require('@/assets/images/REDIS_LOGO.png')"
            alt="Logo REDIS"
            :responsive="false"
          ></b-image>
          <b-image
            class="logos column is-3_5 is-justified-center"
            :src="require('@/assets/images/ELASTICSEARCH_LOGO.png')"
            alt="Logo ELASTICSEARCH"
            :responsive="false"
          ></b-image>
          <b-image
            class="logos column is-3_5 is-justified-center"
            :src="require('@/assets/images/SENTRY_LOGO.png')"
            alt="Logo SENTRY"
            :responsive="false"
          ></b-image>
          <b-image
            class="logos column is-3_5 is-justified-center"
            :src="require('@/assets/images/LACUNA_LOGO.png')"
            alt="Logo LACUNA"
            :responsive="false"
          ></b-image>
          <b-image
            class="logos column is-3_5 is-justified-center"
            :src="require('@/assets/images/GITLAB_LOGO.png')"
            alt="Logo GITLAB"
            :responsive="false"
          ></b-image>
          <b-image
            class="logos column is-3_5 is-justified-center"
            :src="require('@/assets/images/AWS_LOGO.png')"
            alt="Logo AWS"
            :responsive="false"
          ></b-image>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { App, General } from "@/utils/constants";
import { mapGetters } from "vuex";

export default {
  name: "ModalPartnership",

  data() {
    return {
      App,
      General
    };
  },

  computed: {
    ...mapGetters({
      version: "getLastVersion"
    }),

    getVersion() {
      return this.version ? this.version.version : "1.0.0";
    },

    getVersionDate() {
      return this.version ? new Date(this.version.date) : new Date();
    }
  },

  methods: {
    close() {
      this.$parent.close();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables";

.modal-card {
  background-color: #ffffff;
  overflow: auto;
  max-height: calc(100vh - 200px);
}
.header-partnership {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 15px;
  border-bottom: 1px solid $grey-light;
}

.card-body {
  display: flex;
  flex-direction: column;
  padding: 15px;
  margin-bottom: 20px;
}

.label-section {
  background-color: #f2f2f2;
  padding: 5px;
  font-size: 1rem;
  font-weight: 600;
}

.close-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  margin-left: auto;
  cursor: pointer;
  &:hover {
    opacity: 0.7;
  }
  background-color: $grey-lighter;
  border-radius: 12px;
}

.is-justified-center {
  display: flex;
  justify-content: center;
}

.is-3_5 {
  flex: none;
  width: 20%;
}

.link {
  margin-top: 5px;
  text-decoration: underline;
  font-weight: 600;
  width: fit-content;
}
</style>
